import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import TableContainer from '../../../Components/Common/TableContainer';
import { PageHeader } from '../../../Components/Custom/PageHeader';
import { SearchInputFilter } from '../../../Components/Custom/SearchInputFilter';
import { SearchSubmitButton } from '../../../Components/Custom/SearchSubmitButton';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { setDocumentTitle } from '../../../helpers/helpers';
import { columns } from './columns';
import { getTradingTeamBonus } from './slice';

const PAGE_TITLE = 'Trading Team Bonus';

const TradingTeamBonusPage = () => {
  const dispatch = useAppDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const { loading, data } = useAppSelector((state) => state.tradingTeamBonus);
  const [id, setId] = useState(searchParams.get('id') || '');

  useEffect(() => {
    if (id) {
      dispatch(getTradingTeamBonus(Number(id)));
    }
  }, [searchParams]);

  setDocumentTitle(PAGE_TITLE);

  return (
    <div className='page-content'>
      <Container fluid>
        <BreadCrumb title={PAGE_TITLE} pageTitle='Bonuses' />
        <Row>
          <Col lg={12}>
            <Card id='orderList'>
              <PageHeader loading={loading} title={PAGE_TITLE} />
              <CardBody className='pt-0'>
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    setSearchParams({ id });
                  }}>
                  <CardBody className='border border-dashed border-end-0 border-start-0'>
                    <Row>
                      <Col md={3} sm={4}>
                        <SearchInputFilter
                          onChange={(e: any) => setId(e.target.value)}
                          value={id}
                          placeholder='Search User ID'
                        />
                      </Col>
                      <Col md={3} sm={4}>
                        <SearchSubmitButton />
                      </Col>
                    </Row>
                  </CardBody>
                </form>
                <TableContainer
                  columns={columns}
                  data={data.userTradingBonuses || []}
                  divClass='table-responsive table-card mb-1'
                  tableClass='align-middle table-nowrap'
                  theadClass='table-light text-muted'
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default TradingTeamBonusPage;
